export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10849.e9a3e1fa.jpg";